import { ReactComponent as FileSvg } from "assets/import-file.svg";
import { useTranslation } from "react-i18next";
import styles from "./import-modal.module.scss";

interface ImportModalContentProps {
  loading: boolean;
  onChangeFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImportModalContent: React.FC<ImportModalContentProps> = ({
  loading,
  onChangeFile
}) => {
  const [t] = useTranslation();

  return (
    <div className={styles.modal}>
      <input
        className={styles.uploadIpt}
        onClick={(e) => e.stopPropagation()}
        onChange={onChangeFile}
        type="file"
        accept=".geojson"
      />

      <div className={styles.import}>
        {!loading && (
          <div className={styles.upload}>
            <FileSvg className={styles.icon} />
            <div className={styles.text1}>{t("myShapes.modal.text1")}</div>

            <div className={styles.text2}>
              <div>{t("myShapes.modal.text2")}</div>&nbsp;
              <div style={{ color: "green" }}>{t("myShapes.modal.text3")}</div>
              &nbsp;
              <div>{t("myShapes.modal.text4")}</div>&nbsp;
            </div>
          </div>
        )}

        {loading && (
          <div className={styles.loading_wrapper}>
            <div
              className="loading loading-spinner"
              style={{ color: "#666" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImportModalContent;
